import { Component, Injectable, OnInit } from '@angular/core';
import { StorageService } from '../../core/storage/storageService';
import { UIErrorHandler } from '../../core/uiErrorHandler';
import { ServerError } from '../errors/serverError';
import { BasePage } from '../../pages/BasePage';

@Injectable({ providedIn: 'root' })
export class PageRequirements {
  requireLogin?: boolean;
}

@Component({
  template: '',
  standalone: false,
})
export abstract class CPOPage extends BasePage implements OnInit {
  constructor(
    private __storage: StorageService,
    private __uiErrorHandler: UIErrorHandler,
    private __pageRequirements: PageRequirements = {},
  ) {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.checkRequirements();
  }

  private checkRequirements() {
    if (
      this.__pageRequirements.requireLogin &&
      this.__storage.getCurrentUser() == null
    ) {
      this.__uiErrorHandler.handleError({
        code: ServerError.ERR_NOT_SIGNED_IN,
      });
    }
  }
}
